import React from 'react';
import moment from 'moment-timezone';
import Modal from '../../commons/modal/modal';
import styles from './ceTaskboard.scss';
import {
  convertMsToAmPm,
  generateExcludeTimes,
  generateSlotsToDisplay,
  getFormattedDateAndTime,
  getIfADNewFlowApplied,
  getOrSetSessionPropertyValue,
  strUsables
} from '../../../services/helpers';
import {
  isAppointmentDelivery,
  deliveryTypeList,
  isStatusPending,
  isOfdAppointmentReschedule,
  deliveryClientList,
  appointmentDeliveryTypeList,
  getDeliveryTypeDisplayName
} from '../../helper/DeliveryTypeHelper';
import {
  defaultPODetail,
  isPoDetailsRequired
} from '../../helper/PurchaseOrderHelper';
import DatePicker from '../../commons/datePicker/datePicker';
import InputField from '../../commons/formElements/inputField/inputField';
import {
  getAdHolidayDate,
  getConsignmentAppointmentDetails
} from './ceTaskboardRedux/ceTaskboardActionCreator';
import BasicSelect from '../../commons/formElements/basicSelect/basicSelect';
import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../services/apiService/apiService';

const addIcon = require('../../../assets/images/add_button_dark_green_icn.svg');
const closeIcon = require('../../../assets/images/close_icn.svg');

class CreateNewAppointmentTaskModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      cnote: '',
      timeSlotOptions: [],
      appointmentDateTimeSlot: '',
      startSlot: null,
      endSlot: null,
      excludeTimes: [],
      holidayMsg: '',
      isAppointmentDateTimeSlotted: false,
      previousDeliveryType: null,
      minLimitForDateAppointment: 0,
      maxLimitForDateAppointment: null,
      minLimitForDateTimeAppointment: 0,
      maxLimitForDateTimeAppointment: null,
      minDateLimit: 0,
      maxDateLimit: null
    };
    this.onClose = this.onClose.bind(this);
  }

  componentDidMount() {
    const { userProfile } = this.props;
    getOrSetSessionPropertyValue(
      userProfile,
      'DATE_TYPE_APPOINTMENT_DELIVERY_MIN_LIMIT',
      0,
      flag => {
        this.setState({ minLimitForDateAppointment: flag });
      }
    );
    getOrSetSessionPropertyValue(
      userProfile,
      'DATE_TYPE_APPOINTMENT_DELIVERY_MAX_LIMIT',
      null,
      flag => {
        this.setState({ maxLimitForDateAppointment: flag });
      }
    );
    getOrSetSessionPropertyValue(
      userProfile,
      'SLOTTED_APPOINTMENT_DELIVERY_MIN_LIMIT',
      0,
      flag => {
        this.setState({ minLimitForDateTimeAppointment: flag });
      }
    );
    getOrSetSessionPropertyValue(
      userProfile,
      'SLOTTED_APPOINTMENT_DELIVERY_MAX_LIMIT',
      null,
      flag => {
        this.setState({ maxLimitForDateTimeAppointment: flag });
      }
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rowData !== this.props.rowData) {
      this.setState(
        prevState => {
          return {
            data: Object.assign({}, prevState.data, nextProps.rowData)
          };
        },
        () => {
          let adFlag = getIfADNewFlowApplied(
            this.props.userProfile,
            this.state.data.areAdNewChangesEnabled,
            this.state.data.currentOUCode
          );
          if (adFlag != this.state.isAppointmentDateTimeSlotted) {
            this.setState({
              isAppointmentDateTimeSlotted: adFlag,
              timeSlotOptions: [],
              appointmentDateTimeSlot: null
            });
          }
          if (!adFlag) {
            this.setState({
              timeSlotOptions: [],
              appointmentDateTimeSlot: null
            });
          }
          this.onPopupFirstTimeOpenHandler(adFlag);
        }
      );
    }
  }

  onPopupFirstTimeOpenHandler(adFlag) {
    if (
      this.state.data &&
      this.state.data.deliveryType === strUsables.APPOINTMENT &&
      this.state.data.appointmentDeliveryType
    ) {
      if (
        adFlag &&
        Array.isArray(this.state.timeSlotOptions) &&
        this.state.timeSlotOptions.length <= 0
      ) {
        this.getTimeSlotsForADType(this.state.data.appointmentDeliveryType);
      }
      this.getMinOrMaxDate();
    }
  }

  onCnoteChange(cnote) {
    this.setState({
      cnote
    });
  }

  getMinOrMaxDate = () => {
    const {
      appointmentDeliveryType,
      minimumDeliveryDateTime,
      edd,
      appointmentDeliveryMinLimit,
      appointmentDeliveryMaxLimit
    } = this.state.data;

    const {
      isAppointmentDateTimeSlotted: flag,
      minLimitForDateTimeAppointment,
      maxLimitForDateTimeAppointment,
      minLimitForDateAppointment,
      maxLimitForDateAppointment
    } = this.state;

    let dateBasedOnPreviousDeliveryType = minimumDeliveryDateTime;
    if (this.state.previousDeliveryType !== 'APPOINTMENT' && flag && edd) {
      dateBasedOnPreviousDeliveryType = edd;
    }
    const baseDate = dateBasedOnPreviousDeliveryType
      ? moment(dateBasedOnPreviousDeliveryType)
      : moment();

    let minLimit = 0;
    let maxLimit = null;

    if (appointmentDeliveryType === 'DATE_TIME_APPOINTMENT') {
      minLimit = minLimitForDateTimeAppointment;
      maxLimit = maxLimitForDateTimeAppointment;
    } else if (flag) {
      minLimit = minLimitForDateAppointment;
      maxLimit = maxLimitForDateAppointment;
    } else {
      minLimit = appointmentDeliveryMinLimit;
      maxLimit = appointmentDeliveryMaxLimit;
    }

    this.setState({
      minDateLimit: baseDate
        .clone()
        .add(minLimit || 0, 'days')
        .startOf('day')
        .toDate(),
      maxDateLimit:
        maxLimit != null
          ? baseDate
              .clone()
              .add(maxLimit, 'days')
              .endOf('day')
              .toDate()
          : null
    });
  };

  getTimeSlotsForADType(appointmentDeliveryType) {
    if (
      appointmentDeliveryType &&
      appointmentDeliveryType !== 'DATE_TIME_APPOINTMENT'
    ) {
      return;
    }
    const requestObj = {
      baseUrl: 'zoomApiUrl',
      apiEndPoint: 'getADTimeSlots',
      method: 'GET',
      replaceParamsArr: [
        {
          key: 'deliveryType',
          val: appointmentDeliveryType
        },
        {
          key: 'appointmentId',
          val: (this.state.data && this.state.data.appointmentRecordId) || null
        }
      ],
      successCb: response => {
        if (response && response.payload && response.payload.slots) {
          console.log('Success: Slots fetched successfully.');
          if (
            response.payload.existingAppointmentTimeSlot &&
            this.state.data &&
            this.state.data.appointmentDeliveryType
          ) {
            let slot = [response.payload.existingAppointmentTimeSlot];
            let timeslot = generateSlotsToDisplay(slot)[0];
            this.setState({
              appointmentDateTimeSlot: timeslot || null
            });
          }

          this.setState({
            timeSlotOptions: generateSlotsToDisplay(response.payload.slots).map(
              elem => ({
                key: elem,
                val: elem
              })
            )
          });
        } else {
          toastr.error('Error', `Can not get appointment time slots.`);
          this.setState({
            timeSlotOptions: []
          });
        }
      },
      failureCb: () => {
        this.setState({
          timeSlotOptions: []
        });
        toastr.error(
          'Something went wrong!',
          'Failed to get appointment time slots.'
        );
      },
      catchCb: () => {
        this.setState({
          timeSlotOptions: []
        });
        toastr.error(
          'Something went wrong!',
          'Unable to get appointment time slots.'
        );
      }
    };

    return makeApiCall(requestObj);
  }

  setSlotTimeInMillis = function() {
    let slotStartTimeMillis,
      slotEndTimeMillis = '';
    if (
      !(
        this.state.data &&
        this.state.appointmentDateTimeSlot &&
        this.state.data.appointmentTime
      )
    ) {
      const endDateTimeMillis = moment(
        this.state.data.appointmentTime
      ).valueOf();
      slotStartTimeMillis = null;
      slotEndTimeMillis = endDateTimeMillis;
      return { start: null, end: slotEndTimeMillis };
    }

    // Split selected slot
    let slotParts = this.state.appointmentDateTimeSlot.split('-');
    let startTimeStr = slotParts[0].trim();
    let endTimeStr = slotParts[1].trim();

    // Clone the date part only
    let date = moment(this.state.data.appointmentTime)
      .clone()
      .startOf('day');

    // Combine date with time
    let startDateTime = moment(
      date.format('YYYY-MM-DD') + ' ' + startTimeStr,
      'YYYY-MM-DD hh:mm A'
    );
    let endDateTime = moment(
      date.format('YYYY-MM-DD') + ' ' + endTimeStr,
      'YYYY-MM-DD hh:mm A'
    );

    // Save milliseconds
    slotStartTimeMillis = startDateTime.valueOf();
    slotEndTimeMillis = endDateTime.valueOf();
    return { start: slotStartTimeMillis, end: slotEndTimeMillis };
  };

  onCnoteKeyPress(event) {
    if (event.key === 'Enter') {
      getConsignmentAppointmentDetails(this.state.cnote, data =>
        this.setState({ data }, () => {
          this.props.getPoDetailsByConsignmentId(this.state.data.id);
        })
      );
    }
  }

  onAppointmentIdChange(appointmentId) {
    this.setState({ data: Object.assign(this.state.data, { appointmentId }) });
  }

  onAppointmentTimeChange(appointmentTimeMoment) {
    if (!this.state.isAppointmentDateTimeSlotted) {
      // excluding timestamps feature, commenting code for future reference
      const selectedTimeStamp = moment(appointmentTimeMoment)
        .clone()
        .tz('Asia/Kolkata')
        .startOf('day')
        .valueOf();
      const currentTimestamp = moment()
        .tz('Asia/Kolkata')
        .startOf('day')
        .valueOf();

      const excludeTimes =
        selectedTimeStamp === currentTimestamp &&
        (this.state.data.minimumDeliveryDateTime ||
          !this.state.data.appointmentDeliveryMinLimit)
          ? generateExcludeTimes()
          : [];

      this.setState({
        excludeTimes: excludeTimes
      });
    }

    this.setState({
      data: Object.assign(this.state.data, {
        appointmentTime: appointmentTimeMoment.valueOf()
      })
    });
  }

  onDeliveryTypeChange(deliveryType) {
    // in case delivery type is APPOINTMENT, then we don't send the delivery client
    // hence we set is as null over here
    this.setState({
      previousDeliveryType: this.state.data.deliveryType,
      data: Object.assign(this.state.data, {
        deliveryType,
        deliveryClient: null
      })
    });
    this.getMinOrMaxDate();

    if (this.state.isAppointmentDateTimeSlotted) {
      let adType =
        deliveryType === strUsables.APPOINTMENT
          ? strUsables.DATE_APPOINTMENT
          : strUsables.NOT_APPLICABLE;
      if (
        this.props &&
        this.props.rowData &&
        ((this.props.rowData.appointmentDeliveryType &&
          this.props.rowData.appointmentDeliveryType ===
            strUsables.ODA_APPOINTMENT) ||
          this.props.rowData.isDeliveryPincodeODA) &&
        deliveryType === strUsables.APPOINTMENT
      ) {
        adType = strUsables.ODA_APPOINTMENT;
      }
      this.setState({
        data: Object.assign(this.state.data, {
          appointmentDeliveryType: adType
        })
      });
    }
  }

  onAppointmentDeliveryTypeChange(appointmentDeliveryType) {
    this.getTimeSlotsForADType(appointmentDeliveryType);
    this.setState({
      data: Object.assign(this.state.data, {
        appointmentDeliveryType: appointmentDeliveryType
      })
    });
    if (
      this.state.data.appointmentDeliveryType ===
      strUsables.DATE_TIME_APPOINTMENT
    ) {
      this.setState({
        data: Object.assign(this.state.data, {
          appointmentDateTimeSlot: null
        })
      });
    }
    this.getMinOrMaxDate();
  }

  onDeliveryClientChange(deliveryClient) {
    this.setState({
      data: Object.assign(this.state.data, {
        deliveryClient,
        fcName: null,
        purchaseOrderDTOs: [{ ...defaultPODetail }]
      })
    });
  }

  onClose() {
    this.props.closeModal();
    this.setState({
      cnote: '',
      data: {}
    });
  }

  onFcNameSelect(val) {
    if (val) {
      this.setState({
        data: Object.assign(this.state.data, {
          fcName: val
        })
      });
    }
  }

  handleSubmit(isDeliveryFieldsEditable) {
    if (this.props.isSubmitButtonDisabled || !this.state.data.cnote) {
      return;
    }

    let data = Object.assign({}, this.state.data);
    if (this.state.isAppointmentDateTimeSlotted) {
      let obj = this.setSlotTimeInMillis();
      if (
        this.state.data.deliveryType === strUsables.APPOINTMENT &&
        this.state.data.appointmentDeliveryType &&
        this.state.data.appointmentDeliveryType ===
          strUsables.DATE_TIME_APPOINTMENT &&
        (!this.state.data.appointmentTime ||
          !this.state.appointmentDateTimeSlot) &&
        this.state.data.deliveryClient !== 'BLINKIT'
      ) {
        toastr.error(
          'Error',
          'Appointment date & time selection is mandatory.'
        );
        return;
      } else if (!this.state.data.deliveryType) {
        toastr.error(
          'Error',
          'Delivery type can not be null. Please select delivery type to submit.'
        );
        return;
      }
      if (
        this.state.data.deliveryType === strUsables.APPOINTMENT &&
        this.state.data.appointmentDeliveryType &&
        this.state.data.appointmentTime
      ) {
        if (
          this.state.data.appointmentDeliveryType === 'DATE_TIME_APPOINTMENT'
        ) {
          data.appointmentTime = obj.end;
          data.appointmentStartTime = obj.start;
        } else {
          const endDate = new Date(obj.end);
          endDate.setHours(23, 59, 59, 0);
          data.appointmentTime = endDate.getTime();
          data.appointmentStartTime = null;
        }
      }
    }
    this.props.scheduleTask(data, this.onClose, isDeliveryFieldsEditable);
  }

  onTimeSlotSelect(val) {
    if (val) {
      this.setState({
        appointmentDateTimeSlot: val
      });
    }
  }

  returnSelectedOption() {
    let slot = null;
    if (
      !this.state.appointmentDateTimeSlot &&
      this.state.data &&
      this.state.data.appointmentDeliveryType &&
      this.state.data.appointmentDeliveryType ===
        strUsables.DATE_TIME_APPOINTMENT &&
      this.state.data.appointmentStartTime &&
      this.state.data.appointmentTime
    ) {
      slot =
        convertMsToAmPm(this.state.data.appointmentStartTime) +
        ' - ' +
        convertMsToAmPm(this.state.data.appointmentTime);
      this.setState({
        appointmentDateTimeSlot: slot
      });
    }
    return this.state.appointmentDateTimeSlot || slot;
  }

  addPoDetail() {
    this.setState(prevState => {
      const poDtos = [...prevState.data.purchaseOrderDTOs];
      poDtos.push({ ...defaultPODetail });
      return {
        data: Object.assign(prevState.data, {
          purchaseOrderDTOs: [...poDtos]
        })
      };
    });
  }

  deletePoDetail(index) {
    this.setState(prevState => {
      const poDtos = [...prevState.data.purchaseOrderDTOs];
      poDtos.splice(index, 1);
      return {
        data: Object.assign(prevState.data, {
          purchaseOrderDTOs: [...poDtos]
        })
      };
    });
  }

  onPoDetailsChange(val, index, field) {
    this.setState(prevState => {
      const poDtos = [...prevState.data.purchaseOrderDTOs];
      switch (field) {
        case 'po':
          poDtos[index].po = val;
          break;
        case 'units':
          poDtos[index].units = val;
          break;
        case 'poExpiryTime':
          poDtos[index].poExpiryTime = val.valueOf();
          break;
      }
      return {
        data: Object.assign(prevState.data, {
          purchaseOrderDTOs: [...poDtos]
        })
      };
    });
  }

  didPoDetailsNeedToRender() {
    return (
      isAppointmentDelivery(this.state.data.deliveryType) &&
      this.props.isPoDetailsLoading === false &&
      this.state.data.purchaseOrderDTOs &&
      !!this.state.data.purchaseOrderDTOs.length
    );
  }

  checkAdDateHoliday(date, toPinCode) {
    getAdHolidayDate(
      {
        appointmentDateTime: moment(date).valueOf(),
        toPinCode
      },
      res => {
        this.setState({ holidayMsg: res.payload });
      },
      () => {
        this.setState({ holidayMsg: '' });
      }
    );
  }

  render() {
    // T37879: after OFD only the appointment date or time slot may change.
    const isOfdReschedule = isOfdAppointmentReschedule(
      this.state.data,
      this.props.userProfile
    );
    const isDeliveryFieldsEditable =
      !isOfdReschedule &&
      (this.state.data && this.state.data.appointmentStatus
        ? isStatusPending(this.state.data.appointmentStatus)
        : true);
    const fcNameOptions =
      isPoDetailsRequired(this.state.data.deliveryClient) &&
      this.state.data.fcNameHash
        ? this.state.data.fcNameHash[
            this.state.data.deliveryClient.toUpperCase()
          ]
        : [];
    const renderPODetailsComponents =
      !isOfdReschedule &&
      (isDeliveryFieldsEditable ||
        !isPoDetailsRequired(
          this.state.data && this.state.data.deliveryClient
        ));
    const purchaseOrderDTOs = Array.isArray(this.state.data.purchaseOrderDTOs)
      ? this.state.data.purchaseOrderDTOs.filter(
          poDetail =>
            !isOfdReschedule ||
            poDetail.po ||
            poDetail.units ||
            poDetail.poExpiryTime
        )
      : [];
    return (
      <Modal
        showModal={this.props.showModal}
        title={
          this.state.data.cnote
            ? `CN# ${this.state.data.cnote}`
            : 'Create New Task'
        }
        closeModal={() => {
          this.setState({ holidayMsg: '' });
          this.onClose();
        }}
        modalTheme={{
          name: 'themeGreyLarge'
        }}
      >
        <div
          className={`l-col ${styles.modalContentWrapper}`}
          style={{ paddingBottom: '0' }}
        >
          {this.state.data.cnote ? (
            <div className={`flex-100 ${styles.modalBody}`}>
              <div className={`l-row j-space-bet ${styles.modalRow}`}>
                <div className="flex-30">
                  <div className={styles.smallText}>Client (Code)</div>
                  <div className={styles.text}>
                    {`${this.state.data.clientName} (${this.state.data.clientCode})`}
                  </div>
                </div>
                <div className="flex-30">
                  <div className={styles.smallText}>Consignor Details</div>
                  <div className={styles.text}>
                    {this.state.data.consignorName}
                  </div>
                </div>
                <div className="flex-30">
                  <div className={styles.smallText}>Consignee Details</div>
                  <div className={styles.text}>
                    {this.state.data.consigneeName}
                  </div>
                </div>
              </div>
              <div className={`l-row j-space-bet ${styles.modalRow}`}>
                <div className="flex-30">
                  <div className={styles.smallText}>Booking Date and Time</div>
                  <div className={styles.text}>
                    {getFormattedDateAndTime(this.state.data.bookingDateTime)}
                  </div>
                </div>
                <div className="flex-30">
                  <div className={styles.smallText}>EDD</div>
                  <div className={styles.text}>
                    {this.state.data && this.state.data.edd
                      ? getFormattedDateAndTime(this.state.data.edd)
                      : '--'}
                  </div>
                </div>
                <div className="flex-30">
                  <div className={styles.smallText}>CPD</div>
                  <div className={styles.text}>
                    {this.state.data.promisedDeliveryDateTime
                      ? getFormattedDateAndTime(
                          // this.state.data.minimumDeliveryDateTime ||
                          this.state.data.promisedDeliveryDateTime
                        )
                      : '-'}
                  </div>
                </div>
              </div>
              <div className={`l-row j-space-bet ${styles.modalRow}`}>
                <div className="flex-30">
                  <div className={styles.smallText}>Delivery Type</div>
                  {isDeliveryFieldsEditable ? (
                    <BasicSelect
                      label="Select Delivery Type"
                      selectedOpt={getDeliveryTypeDisplayName(
                        this.state.data.deliveryType
                      )}
                      optionsArrOfObj={deliveryTypeList}
                      onSelect={(value, obj) => {
                        this.onDeliveryTypeChange(obj ? obj.key : value);
                      }}
                      nameValStrings={{ nameKey: 'val', valKey: 'val' }}
                    />
                  ) : (
                    <div className={styles.text}>
                      {getDeliveryTypeDisplayName(this.state.data.deliveryType)}
                    </div>
                  )}
                </div>
                {this.state.data &&
                this.state.data.deliveryType === strUsables.APPOINTMENT ? (
                  <div className="flex-30">
                    <div className={styles.smallText}>Delivery Client</div>
                    {isDeliveryFieldsEditable ? (
                      <BasicSelect
                        label="Select Delivery Client"
                        selectedOpt={this.state.data.deliveryClient}
                        optionsArrOfObj={deliveryClientList}
                        onSelect={value => {
                          this.onDeliveryClientChange(value);
                        }}
                        disableNone={true}
                      />
                    ) : (
                      <div className={styles.text}>
                        {this.state.data.deliveryClient}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="flex-30" />
                )}
                <div className="flex-30" />
              </div>
              <div className={`l-row j-space-bet ${styles.modalRow}`}>
                {this.state.isAppointmentDateTimeSlotted &&
                  isAppointmentDelivery(this.state.data.deliveryType) && (
                    <React.Fragment>
                      <div className="flex-50">
                        <div className={styles.smallText}>
                          Appointment Delivery Type
                        </div>
                        {isDeliveryFieldsEditable &&
                        this.state.data &&
                        this.state.data.appointmentDeliveryType &&
                        this.state.data.appointmentDeliveryType !==
                          strUsables.ODA_APPOINTMENT &&
                        !this.state.data.isDeliveryPincodeODA ? (
                          <BasicSelect
                            label="Select Appointment Type"
                            selectedOpt={
                              this.state.data.appointmentDeliveryType
                            }
                            optionsArrOfObj={appointmentDeliveryTypeList}
                            onSelect={value => {
                              this.onAppointmentDeliveryTypeChange(value);
                            }}
                            disableNone={true}
                          />
                        ) : (
                          <div className={styles.text}>
                            {this.state.data &&
                              (this.state.data.appointmentDeliveryType
                                ? this.state.data.isDeliveryPincodeODA
                                  ? 'ODA_APPOINTMENT'
                                  : this.state.data.appointmentDeliveryType
                                : '--')}
                          </div>
                        )}
                      </div>
                    </React.Fragment>
                  )}
              </div>
              <div className={`l-row j-space-bet ${styles.modalRow}`}>
                {isAppointmentDelivery(this.state.data.deliveryType) && (
                  <React.Fragment>
                    <div className="flex-30">
                      <div className={styles.smallText}>
                        Appointment ID / PO Number
                      </div>
                      <div className={styles.text}>
                        {isOfdReschedule ? (
                          this.state.data.appointmentId || '--'
                        ) : (
                          <InputField
                            maxLength="255"
                            placeholder="Enter Appointment ID / PO Number"
                            type="text"
                            value={this.state.data.appointmentId}
                            onChange={val => this.onAppointmentIdChange(val)}
                          />
                        )}
                      </div>
                    </div>
                    <div className="flex-30">
                      <div className={styles.smallText}>Appointment Date</div>
                      <DatePicker
                        name="Appointment Date"
                        startDate={
                          this.state.data.appointmentTime &&
                          new Date(this.state.data.appointmentTime)
                        }
                        onChange={val => {
                          if (
                            this.state.data &&
                            this.state.data.toPinCode &&
                            val
                          ) {
                            this.checkAdDateHoliday(
                              val,
                              this.state.data.toPinCode
                            );
                          }
                          this.onAppointmentTimeChange(val);
                        }}
                        placeholderText={
                          this.state.isAppointmentDateTimeSlotted
                            ? 'Appointment Date'
                            : 'Appointment Time'
                        }
                        showTimeSelect={
                          !this.state.isAppointmentDateTimeSlotted
                        }
                        timeFormat={
                          this.state.isAppointmentDateTimeSlotted
                            ? null
                            : 'hh:mm aa'
                        }
                        dateFormat={
                          this.state.isAppointmentDateTimeSlotted
                            ? 'MMM dd, yyyy'
                            : 'MMM dd, yyyy hh:mm aa'
                        }
                        minDate={this.state.minDateLimit}
                        maxDate={this.state.maxDateLimit}
                        {...(this.state.data.appointmentTime &&
                          !this.state.isAppointmentDateTimeSlotted && {
                            excludeTimes: this.state.excludeTimes
                          })}
                        className={
                          isOfdReschedule
                            ? `prq-date-picker no-margin ${styles.editableField}`
                            : 'prq-date-picker no-margin'
                        }
                      />
                      {!!this.state.holidayMsg && (
                        <div className={styles.adHolidayDate}>
                          The AD date selected is{' '}
                          <span style={{ fontWeight: 'bold' }}>
                            {this.state.holidayMsg}
                          </span>{' '}
                          in the Delivery location
                        </div>
                      )}
                    </div>

                    {this.state.isAppointmentDateTimeSlotted &&
                    this.state.data &&
                    this.state.data.appointmentDeliveryType &&
                    this.state.data.appointmentDeliveryType ===
                      strUsables.DATE_TIME_APPOINTMENT ? (
                      <div className="flex-30">
                        <div className={styles.smallText}>
                          Appointment Time Slot
                        </div>
                        <BasicSelect
                          label="Select Time Slot"
                          selectedOpt={this.returnSelectedOption()}
                          optionsArrOfObj={this.state.timeSlotOptions}
                          onSelect={value => {
                            this.onTimeSlotSelect(value);
                          }}
                          disableNone={true}
                        />
                      </div>
                    ) : (
                      <div className="flex-30" />
                    )}
                  </React.Fragment>
                )}
              </div>
              {this.didPoDetailsNeedToRender() &&
                isPoDetailsRequired(this.state.data.deliveryClient) &&
                this.state.data.deliveryClient !== 'BLINKIT' && (
                  <div className={`l-row j-space-bet ${styles.modalRow}`}>
                    <div className="flex-30">
                      <div className={styles.smallText}>FC Name</div>
                      {isDeliveryFieldsEditable ? (
                        <BasicSelect
                          label="Select FC Name"
                          selectedOpt={this.state.data.fcName}
                          optionsArrOfObj={fcNameOptions}
                          onSelect={value => {
                            this.onFcNameSelect(value);
                          }}
                          disableNone={true}
                        />
                      ) : (
                        <div className={styles.text}>
                          {this.state.data.deliveryType}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              {this.didPoDetailsNeedToRender() &&
                purchaseOrderDTOs.map((poDetail, index) => (
                  <div
                    key={index}
                    className={`l-row j-space-bet ${styles.modalRow}`}
                  >
                    <div className="flex-25">
                      <div className={styles.smallText}>PO Number</div>
                      {renderPODetailsComponents ? (
                        <div className={styles.text}>
                          <InputField
                            maxLength="255"
                            placeholder="Enter PO Number"
                            type="text"
                            value={poDetail.po}
                            onChange={val =>
                              this.onPoDetailsChange(val, index, 'po')
                            }
                          />
                        </div>
                      ) : (
                        <div className={styles.text}>{poDetail.po}</div>
                      )}
                    </div>
                    <div className="flex-25">
                      <div className={styles.smallText}>No. of Units</div>
                      {renderPODetailsComponents ? (
                        <div className={styles.text}>
                          <InputField
                            maxLength="255"
                            placeholder="Enter No of Units"
                            type="text"
                            allowedInputKeys="onlynumber"
                            value={String(poDetail.units)}
                            onChange={val =>
                              this.onPoDetailsChange(val, index, 'units')
                            }
                          />
                        </div>
                      ) : (
                        <div className={styles.text}>{poDetail.units}</div>
                      )}
                    </div>
                    <div className="flex-30">
                      <div className={styles.smallText}>Expiry Date</div>
                      {renderPODetailsComponents ? (
                        <div className={styles.text}>
                          <DatePicker
                            name="Enter Expiry Date"
                            startDate={
                              poDetail.poExpiryTime &&
                              new Date(poDetail.poExpiryTime)
                            }
                            onChange={val =>
                              this.onPoDetailsChange(val, index, 'poExpiryTime')
                            }
                            placeholderText="Expiry Time"
                            showTimeSelect={true}
                            timeFormat="hh:mm aa"
                            dateFormat="MMM dd, yyyy hh:mm aa"
                            minDate={new Date()}
                            className="prq-date-picker no-margin"
                          />
                        </div>
                      ) : (
                        <div className={styles.text}>
                          {poDetail.poExpiryTime
                            ? getFormattedDateAndTime(poDetail.poExpiryTime)
                            : '--'}
                        </div>
                      )}
                    </div>
                    {renderPODetailsComponents && (
                      <div className="flex-10">
                        {index === 0 ? (
                          <button
                            className={styles.addPoButton}
                            onClick={e => this.addPoDetail()}
                          >
                            <img src={addIcon} />
                          </button>
                        ) : (
                          <button
                            className={styles.addPoButton}
                            onClick={e => this.deletePoDetail(index)}
                          >
                            <img src={closeIcon} />
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                ))}
            </div>
          ) : (
            <div className={`flex-100 ${styles.modalBody}`}>
              <InputField
                maxLength="10"
                allowedInputKeys="onlynumber"
                placeholder="Enter Consignment No."
                type="text"
                value={this.state.cnote}
                onChange={val => this.onCnoteChange(val)}
                onKeyPress={event => this.onCnoteKeyPress(event)}
              />
            </div>
          )}
          <div className="l-row j-end a-end">
            <div
              className={`${styles.submitBtnWrapper} l-row j-center a-center ${
                this.props.isSubmitButtonDisabled ? styles.disabledButton : ''
              }`}
              style={{ marginBottom: '2rem' }}
              onClick={() => this.handleSubmit(isDeliveryFieldsEditable)}
            >
              SUBMIT
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
export default CreateNewAppointmentTaskModal;
